import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var GroupBy = /*#__PURE__*/function () {
  function GroupBy() {
    _classCallCheck(this, GroupBy);

    this.key = undefined;
    this.field = undefined;
    this.groupType = undefined;
    this.rows = undefined;
    this.projections = undefined;
    this.subGroups = undefined;
    this.sort = undefined;
  }

  _createClass(GroupBy, [{
    key: "setKey",
    value: function setKey(key) {
      this.key = key;
      return this;
    }
  }, {
    key: "setField",
    value: function setField(field) {
      this.field = field;
      return this;
    }
  }, {
    key: "setGroupType",
    value: function setGroupType(groupType) {
      this.groupType = groupType;
      return this;
    }
  }, {
    key: "setRows",
    value: function setRows(rows) {
      this.rows = rows;
      return this;
    }
  }, {
    key: "addProjection",
    value: function addProjection(projection) {
      if (!this.projections) {
        this.projections = [];
      }

      this.projections.push(projection);
      return this;
    }
  }, {
    key: "setProjections",
    value: function setProjections(projections) {
      this.projections = projections;
      return this;
    }
  }, {
    key: "addSubGroup",
    value: function addSubGroup(subGroup) {
      if (!this.subGroups) {
        this.subGroups = [];
      }

      this.subGroups.push(subGroup);
      return this;
    }
  }, {
    key: "setSubGroups",
    value: function setSubGroups(subGroups) {
      this.subGroups = subGroups;
      return this;
    }
  }, {
    key: "setSort",
    value: function setSort(sort) {
      this.sort = sort;
      return this;
    }
  }]);

  return GroupBy;
}();

export default GroupBy;